export default "__VITE_ASSET__53b0d293__"